/** Read-only client contract for the GTCC Mail & Deliverability summary. */
import { gtccGet, type GtccResult } from "./gtcc-result.js";

export const MAIL_SUMMARY_PATH = "/v1/admin/gtcc/mail/summary";
export const MAIL_SUMMARY_KEY = ["gtcc", "mail", "summary"] as const;

export interface MailSummaryDto {
  readonly provider: "log-only" | "smtp" | "postmark";
  readonly configuredSender: string | null;
  readonly templateLocales: readonly string[];
  readonly deliveries30d: {
    readonly measuredAt: string;
    /** Server-measured age; never derived from the browser clock. */
    readonly freshnessSeconds: number;
    readonly invitations: { readonly total: number; readonly failures: number };
    readonly account: { readonly total: number; readonly failures: number };
    readonly affectedRecipients: number;
    readonly bounces: number;
    readonly spamComplaints: number;
    readonly rejected: number;
  };
  readonly source: "mail_health";
}

export function fetchMailSummary(signal?: AbortSignal): Promise<GtccResult<MailSummaryDto>> {
  return gtccGet<MailSummaryDto>(MAIL_SUMMARY_PATH, signal);
}
